import React, {useRef, useState} from "react";
import Auxiliary from "../../../../../hoc/Auxiliary";
import {Panel} from 'primereact/panel';
import QueryExecutionsList from "./QueryExecutionsList/QueryExecutionsList";
import {Ripple} from 'primereact/ripple';
import {Tooltip} from "primereact/tooltip";
import {Checkbox} from "primereact/checkbox";

const QueryConfiguration = (props) => {

    const template = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-start flex align-items-center w-full`;
        const titleClassName = `${options.titleClassName} pl-1`;
        const sectionName = options.props.title;
        const description = options.props.description;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple/>
                </button>

                <span className={titleClassName}>{sectionName}</span>

                   <span className="pi pi-info-circle iconInfo ml-2"  data-pr-tooltip={description}></span>
                    <Tooltip target=".iconInfo"/>
                <div className="ml-auto flex align-items-center gap-3">
                    {    props.query.executions.some(q => q.status.code === "EXECUTION_IN_PROGRESS")?    <i className="pi pi-spin pi-spinner text-gray-400 text-lg"></i>:null}
                    <Checkbox
                        checked={props.query.isChecked}
                        onChange={() => props.updateCheck(props.query.queryId, !props.query.isChecked)}
                    />
                </div>
            </div>
        )
    }



    return (
        <Auxiliary>
            <Panel
                toggleable
                collapsed={true}
                title={props.query.name}
                headerTemplate={template}
                description={props.query.description}
                key={props.query.queryId}
                className="titleQuery"
            >
                <div>
                    <QueryExecutionsList style={{border: "0px"}}
                                         loadQueriesPage={props.loadQueriesPage}
                                         query={props.query}/>
                    <br/>
                </div>
            </Panel>
        </Auxiliary>
    )
}
export default QueryConfiguration;
